<template>
  <div :class="['container',{'containerGreen' : orderType == 3}]" >
    <div class="x-qrcode">
      <div class="tit">{{orderType == 1 ? '自提' : '堂食' }}</div>
      <div class="code">{{JSON.parse(code).orderShortNum}}</div>
      <div class="tit">商家名称</div>
      <div class="code">{{supplier_name}}</div>
      <div class="tit">{{orderType == 1 ? '自提时间：' : '就餐时间：' }}</div>
      <div class="code">{{deliveryTime}}</div>
<!--      <div class="isShowSuc" v-if="isShowSuc">-->
<!--        <img class="suc-img" src="../assets/images/success_green.png" alt="">-->
<!--        <p class="suc-des">取餐成功，祝您用餐愉快</p>-->
<!--      </div>-->
      <div id="qrcode" v-if="isInvalid != 2"></div>

      <!--      <div style="position: relative">-->
<!--        <div v-show="!isShowSuc" id="qrcode" :class="{'mask-code': isShowRefresh}"></div>-->
<!--        <div class="refreshWrap">-->
<!--          <div class="refresh" v-if="isShowRefresh">二维码已失效，请刷新</div>-->
<!--          <div class="refreshBtn" v-if="isShowRefresh" @click="getStatus(1)">立即刷新</div>-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="isInvalid == 2 && orderType == 3" style="background: rgba(255,255,255,0.50);text-align: center">
        <img class="qr-mask" src="../assets/images/qr-mask.png" alt="">
        <span class="time-out">已过用餐时间，二维码失效</span>
      </div>
      <div style="text-align: center;width:100%">
        <div class="red ac" style="margin-top: .08rem;font-size: .24rem;">{{qrCodeIndate}}</div>
        <div class="tip">取餐时出示给商家/同学，完成堂食或自提订单验证</div>
      </div>
    </div>
  </div>

</template>

<script>
  import QRCode from 'qrcodejs2'
  import {actions} from "../store/actions";
  export default {
    name: "QrCode",
    data () {
      return {
        code: '',
        orderType: '', //1 字体 3堂食
        deliveryTime: '',
        // isShowRefresh: false,
        timer: null,
        number: 0,
        isShowSuc: false,
        supplier_name: '',
        qrCodeIndate: '',
        isInvalid: 0 //0代表正常 1代表未到用餐时间 2代表过了用餐时间二维码失效
      }
    },
    created(){
      this.code = window.localStorage.getItem('Qr-code');
      this.deliveryTime = window.localStorage.getItem('deliveryTime');
      this.supplier_name = window.localStorage.getItem('supplier_name');
      this.orderType = this.$route.query.orderType
      this.qrCodeIndate = window.localStorage.getItem('qrCodeIndate');
      this.isInvalid = window.localStorage.getItem('isInvalid')
    },
    mounted(){
      this.init();
      this.getStatus();
    },
    destroyed() {
      clearInterval(this.timer)
    },
    methods:{
      init(){
        this.qrcode = new QRCode('qrcode',{
          width: 250,
          height: 250,
          text: this.code,
          colorDark: '#000',
          colorLight: '#fff'
        })
      },
      // //查询核销状态
      // getStatus(type) {
      //   let _this = this;
      //   // if(type === 1) {
      //   //   _this.isShowRefresh = false;
      //   // }
      //   _this.timer = setInterval(function () { //每3秒查询一次
      //     actions.getOrderStatus(_this, {orderId: window.localStorage.getItem('orderCode')}, function (data) {
      //       if(data === 3001 ){
      //         _this.number = 0;
      //         // _this.isShowRefresh = false;
      //         _this.isShowSuc = true;
      //         clearInterval(_this.timer);
      //       } else {
      //         _this.number++;
      //         if(_this.number >= 20) {
      //           clearInterval(_this.timer);
      //           // _this.isShowRefresh = true;
      //           _this.number = 0;
      //         }
      //       }
      //     }, function (data) {
      //
      //     })
      //   }, 3000);
      // }
    }
  }
</script>

<style scoped>
.container{
  background: #FFDF00;
  min-height: 100vh;
  /*padding-top: .45rem;*/
  /*padding-bottom: .55rem;*/
  padding: .45rem;

}
.containerGreen{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: .45rem;
  background: #009875;
}
.x-qrcode{
  position: relative;
  width: 100%;
  height: 100%;
  /*margin: .45rem;*/
  /*width: 6.59rem;*/
  /*margin: 0 auto;*/
  background: #fff;
  border-radius: .2rem;
  padding-top: .5rem;
  padding-bottom: .17rem;
  /*min-height: 9.59rem;*/
}
#qrcode{
  width: 100%;
  padding: 0 .65rem .2rem;
  /*width: 5.4rem;*/
  /*height: 5.4rem;*/
  margin: 0 auto;
}

.tit{
  color: #333;
  font-size: .32rem;
  margin-left: .37rem;
}
.code{
  font-family: PingFangSC-Medium;
  font-size: .48rem;
  color: #2F2F2F;
  margin-left: .37rem;
  margin-bottom: .36rem;
}
.tip{
  font-size: .26rem;
  color: #666666;
  margin-top: .1rem;
  text-align: center;
}
.refresh{
  font-size: .36rem;
  color: #F93A2F;
  text-align: center;
  margin-bottom: .24rem;
}
.refreshBtn{
  width: 1.9rem;
  height: .66rem;
  line-height: .66rem;
  border-radius: .72rem;
  margin: 0 auto;
  text-align: center;
  background: #FFF100;;
}
.suc-img{
  width: 1.62rem;
  height: 1.62rem;
  margin: 1.8rem auto .3rem;
}
.suc-des{
  font-size: .36rem;
  color: #333333;
  margin-bottom: 1.86rem;
  font-weight: bold;
  text-align: center;
}
.refreshWrap {
  position: absolute;
  font-family: PingFangSC-Medium;
  top: 2rem;
  margin-left: 1.7rem;
}
.mask-code {
  opacity: .1;
}
.qr-mask {
  width: 5.94rem;
  margin-left: .3rem;
  opacity: .5;
}
.time-out {
  color: #F93A2F;
  font-size: .36rem;
  position: absolute;
  width: 100%;
  left: 0;
  top: 7.96rem;
}
</style>



// WEBPACK FOOTER //
// QrCode.vue?eb670b4a